import lodashGet from 'lodash/get';

/**
 * Immutably sorts an array of objects alphabetically
 * @param arr - array of objects to sort
 * @param path - path to sort by
 */
export const sortAlphabeticallyByPath = (arr, path) => {
  const sortedArray = [].concat(arr);

  return sortedArray.sort((a, b) => {
    const valueA = lodashGet(a, path, '').toUpperCase();
    const valueB = lodashGet(b, path, '').toUpperCase();
    if (valueA < valueB) {
      return -1;
    }
    if (valueA > valueB) {
      return 1;
    }

    return 0;
  });
};

export const sortAlphabeticallyByTitle = (a, b) => {
  const firstTitle = a.title;
  const secondTitle = b.title;
  return firstTitle.localeCompare(secondTitle);
};

export const sortByOrder = (a, b) => a.order - b.order;

export const sortAttributesBySelectedAndTitle = (selectedItems, a, b) => {
  if (selectedItems.includes(a.id)) {
    if (selectedItems.includes(b.id)) {
      return a.title.localeCompare(b.title);
    }
    return -1;
  } else if (selectedItems.includes(b.id)) {
    return 1;
  }
  return a.title.localeCompare(b.title);
};
